import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Star, Heart } from 'lucide-react';

const HomePage = () => {
  const heroImage = "https://images.unsplash.com/photo-1683257199934-3a9822f37645?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMHlhcm4lMjB3b29sJTIwdGV4dHVyZSUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzcyODM4Mzg0fDA&ixlib=rb-4.1.0&q=85";

  const categories = [
    {
      name: 'Toxuma əl işləri',
      description: 'Ənənəvi toxuma sənətkarlığı ilə yaradılmış unikal əsərlər',
      image: 'https://images.unsplash.com/photo-1552335457-a3154a0beec3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxoYW5kbWFkZSUyMGNyb2NoZXQlMjBiYWclMjBjb2xvcmZ1bCUyMGFydGlzdGljfGVufDB8fHx8MTc3MjgzODM3MHww&ixlib=rb-4.1.0&q=85',
      link: '/products',
      color: 'from-brand-accent to-brand-secondary',
    },
    {
      name: 'Kuklalar',
      description: 'Sevgi ilə hazırlanmış dekorativ kuklalar',
      image: 'https://images.unsplash.com/photo-1696414055568-a0a45684be06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxoYW5kbWFkZSUyMHJhZyUyMGRvbGwlMjBjdXRlJTIwYXJ0aXN0aWN8ZW58MHx8fHwxNzcyODM4Mzc1fDA&ixlib=rb-4.1.0&q=85',
      link: '/products',
      color: 'from-brand-primary/80 to-brand-gold',
    },
    {
      name: 'Çantalar',
      description: 'Əl ilə hazırlanmış premium çantalar',
      image: 'https://images.unsplash.com/photo-1770637266187-60cf9d509593?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxoYW5kbWFkZSUyMGNyb2NoZXQlMjBiYWclMjBjb2xvcmZ1bCUyMGFydGlzdGljfGVufDB8fHx8MTc3MjgzODM3MHww&ixlib=rb-4.1.0&q=85',
      link: '/bags',
      color: 'from-brand-secondary to-brand-accent',
    },
  ];

  const features = [
    { icon: Star, title: '100% Əl işi', desc: 'Hər məhsul fərdidir' },
    { icon: Heart, title: 'Sevgi ilə', desc: 'Həvəslə hazırlanır' },
    { icon: Sparkles, title: 'Premium keyfiyyət', desc: 'Ən yaxşı materiallar' },
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center overflow-hidden" data-testid="hero-section">
        {/* Background */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-cream via-brand-accent/30 to-brand-secondary/40" />
          <img
            src={heroImage}
            alt="Əl işi toxuma"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-20 right-20 w-72 h-72 bg-brand-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" />

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <span className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm text-brand-primary px-4 py-2 rounded-full text-sm font-medium mb-6 animate-fade-in">
                <Sparkles className="w-4 h-4" />
                Əl işi sənətkarlığı
              </span>
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight text-brand-brown leading-[1.1] animate-fade-in animation-delay-100">
                Turkan<br />
                <span className="text-brand-primary italic">Rustamova</span>
              </h1>
              <p className="mt-6 text-lg md:text-xl text-brand-muted leading-relaxed max-w-lg mx-auto lg:mx-0 animate-fade-in animation-delay-200">
                Hər bir tikişdə sevgi, hər bir əsərdə ruh. Ənənəvi sənətkarlıq müasir dizayn ilə birləşir.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start animate-fade-in animation-delay-300">
                <Link
                  to="/bags"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-brand-primary to-[#E08E73] text-white px-8 py-4 font-medium hover:shadow-warm-lg hover:scale-105 transition-all duration-300"
                  data-testid="hero-cta-explore"
                >
                  Kolleksiyaya bax
                  <ArrowRight className="w-5 h-5" />
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-brand-brown text-brand-brown px-8 py-4 font-medium hover:bg-brand-brown hover:text-white transition-all duration-300"
                  data-testid="hero-cta-story"
                >
                  Haqqımızda
                </Link>
              </div>
            </div>
            
            {/* Hero Image */}
            <div className="hidden lg:block relative animate-fade-in animation-delay-400">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-brand-primary/20 to-brand-gold/20 rounded-3xl blur-2xl" />
                <img
                  src="https://images.unsplash.com/photo-1770637266187-60cf9d509593?w=800"
                  alt="Əl işi çanta"
                  className="relative rounded-3xl shadow-warm-lg w-full max-w-md mx-auto"
                />
              </div>
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-warm-lg animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-brand-accent rounded-full flex items-center justify-center">
                    <Heart className="w-6 h-6 text-brand-primary" />
                  </div>
                  <div>
                    <p className="font-serif text-2xl text-brand-brown">100+</p>
                    <p className="text-xs text-brand-muted">Məmnun müştəri</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Bar */}
     <section className="py-8 bg-white border-y border-brand-secondary/30">
  <div className="max-w-7xl mx-auto px-6 md:px-12">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {features.map((feature, idx) => (
        <div
          key={idx}
          className="flex flex-col items-center text-center gap-3 p-4"
        >
          <div className="w-14 h-14 rounded-2xl bg-brand-accent/30 flex items-center justify-center">
            <feature.icon className="w-7 h-7 text-brand-primary" />
          </div>

          <p className="font-serif text-lg text-brand-brown">
            {feature.title}
          </p>

          <p className="text-sm text-brand-muted max-w-xs">
            {feature.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Categories Section */}
      <section className="py-20 md:py-28" data-testid="categories-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-16">
            <span className="text-brand-primary text-sm font-medium uppercase tracking-wider">Kolleksiya</span>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-brown mt-3">
              Kateqoriyalar
            </h2>
            <p className="text-brand-muted mt-4 max-w-xl mx-auto">
              Hər bir kateqoriyada unikal əl işləri sizi gözləyir
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {categories.map((category, index) => (
              <Link
                key={category.name}
                to={category.link}
                className="group relative h-[450px] rounded-3xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-500 transform hover:-translate-y-2"
                data-testid={`category-${index}`}
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${category.color} opacity-60`} />
                <div className="absolute inset-0 flex flex-col justify-end p-8">
                  <h3 className="font-serif text-3xl text-white mb-2">
                    {category.name}
                  </h3>
                  <p className="text-white/80 text-sm mb-4">
                    {category.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-white font-medium text-sm group-hover:gap-4 transition-all duration-300">
                    Bax
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section className="py-20 md:py-28 bg-white" data-testid="brand-story-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <img
                    src="https://images.unsplash.com/photo-1735414526681-ef9339138f65?w=400"
                    alt="Əl işi prosesi"
                    className="rounded-2xl w-full h-48 object-cover shadow-warm"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1696414055568-a0a45684be06?w=400"
                    alt="Kukla"
                    className="rounded-2xl w-full h-64 object-cover shadow-warm"
                  />
                </div>
                <div className="space-y-4 pt-8">
                  <img
                    src="https://images.unsplash.com/photo-1770637266187-60cf9d509593?w=400"
                    alt="Çanta"
                    className="rounded-2xl w-full h-64 object-cover shadow-warm"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1552335457-a3154a0beec3?w=400"
                    alt="Toxuma"
                    className="rounded-2xl w-full h-48 object-cover shadow-warm"
                  />
                </div>
              </div>
              
              {/* Experience Badge */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-brand-primary text-white rounded-2xl p-6 shadow-warm-lg">
                <p className="font-serif text-4xl">15+</p>
                <p className="text-sm text-white/80">İllik təcrübə</p>
              </div>
            </div>

            <div>
              <span className="text-brand-primary text-sm font-medium uppercase tracking-wider">Bizim hekayə</span>
              <h2 className="font-serif text-4xl md:text-5xl text-brand-brown mt-3">
                Sevgi ilə yaradılmış<br />
                <span className="text-brand-primary italic">əl işləri</span>
              </h2>
              <p className="mt-6 text-brand-muted leading-relaxed text-lg">
                Hər bir əsərin arxasında saatlarla zəhmət, illərlə təcrübə və ölçüyə gəlməyən sevgi dayanır. Turkan Rustamova brendi ənənəvi Azərbaycan sənətkarlığını müasir dizayn anlayışı ilə birləşdirir.
              </p>
              <p className="mt-4 text-brand-muted leading-relaxed">
                Toxuma əl işlərindən kukalalara, çantalardan dekorativ elementlərə qədər hər bir məhsulumuz fərdi sifarişlə hazırlanır və unikal keyfiyyət daşıyır.
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 mt-8 text-brand-primary font-medium hover:gap-4 transition-all duration-300"
                data-testid="brand-story-link"
              >
                Ətraflı oxu
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 bg-gradient-to-br from-brand-primary via-[#E08E73] to-brand-gold" data-testid="cta-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-white">
            Unikal əl işi əldə edin
          </h2>
          <p className="mt-6 text-white/80 max-w-xl mx-auto text-lg">
            Sifariş vermək və ya suallarınızı soruşmaq üçün bizimlə əlaqə saxlayın
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-primary px-8 py-4 font-medium hover:shadow-lg hover:scale-105 transition-all duration-300"
              data-testid="cta-contact"
            >
              Əlaqə saxla
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/bags"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white text-white px-8 py-4 font-medium hover:bg-white/10 transition-all duration-300"
              data-testid="cta-bags"
            >
              Çantalara bax
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
